<script lang="ts">
  /**
   * Én potte (beholder) tegnet som en oktagon-«planter». Skillevegg-pillen viser
   * antall felt og slår skilleveggen av/på. Feltene stables med en tynn glipe som
   * avslører skillevegg-linja under. Data-drevet på 1–N felt.
   * Med `kopper` (2.0 stor) er oktagonen én halvdel av kassa: koppene står side om
   * side i samme rekkefølge som på kassa, og det finnes ingen skillevegg å slå av/på.
   */
  import type { Plante } from '../lib/database.types';
  import Felt from './Felt.svelte';

  type FeltData = {
    seksjon: number;
    slotLabel: string;
    rolle: 'foran' | 'bak' | 'hel' | 'kopp';
    plante: Plante | null;
    fukt: number | null;
    harProbe?: boolean;
  };

  let {
    navn,
    delt,
    felt,
    harSensor = true,
    lagrer = false,
    kopper = false,
    onToggleSkille,
    onFelt,
  }: {
    navn: string;
    delt: boolean;
    felt: FeltData[];
    harSensor?: boolean;
    lagrer?: boolean;
    /** 2.0 stor: koppene side om side, uten skilleveggknapp. */
    kopper?: boolean;
    onToggleSkille: () => void;
    onFelt: (seksjon: number) => void;
  } = $props();
</script>

<div class="flex-1 min-w-0">
  <div class="flex items-center justify-between mb-2.5 gap-1.5">
    <div class="text-[13px] font-semibold flex-none">{navn}</div>
    {#if !kopper}
    <button
      class="inline-flex items-center gap-1.5 px-2.5 py-[3px] rounded-full text-[10.5px] font-semibold border whitespace-nowrap flex-none transition-all disabled:opacity-50 {delt
        ? 'bg-leaf/10 text-leaf-glow border-leaf/30'
        : 'bg-surface-raised text-text-muted border-border'}"
      onclick={onToggleSkille}
      disabled={lagrer}
      aria-pressed={delt}
      title={delt ? 'Fjern skilleveggen (slå sammen til ett felt)' : 'Sett inn skillevegg (del i to felt)'}
    >
      {delt ? `${felt.length} felt` : '1 felt'}
    </button>
    {/if}
  </div>

  <div
    class="p-[1.5px]"
    style="background:#3b4264; clip-path:polygon(15px 0,calc(100% - 15px) 0,100% 15px,100% calc(100% - 15px),calc(100% - 15px) 100%,15px 100%,0 calc(100% - 15px),0 15px)"
  >
    <div
      class="flex {kopper ? 'flex-row' : 'flex-col'} gap-[1.5px] h-[232px]"
      style="background:#2a3045; clip-path:polygon(14px 0,calc(100% - 14px) 0,100% 14px,100% calc(100% - 14px),calc(100% - 14px) 100%,14px 100%,0 calc(100% - 14px),0 14px)"
    >
      <!-- Sett forfra ligger bakre felt øverst og fremre felt nederst. Koppene i stor
           står fra venstre mot høyre, som på kassa. -->
      {#each kopper ? felt : [...felt].reverse() as f (f.seksjon)}
        <Felt
          plante={f.plante}
          rolle={f.rolle}
          etikett={f.slotLabel}
          fukt={f.fukt}
          harSensor={harSensor && (f.harProbe ?? true)}
          onClick={() => onFelt(f.seksjon)}
        />
      {/each}
    </div>
  </div>
</div>
